import axios, { AxiosResponse } from "axios";
import { User } from "../types/user";

const userDataUrl = "/assets/data/form-data.json";

export const getUserData = () => {
  return axios.get(userDataUrl) as Promise<AxiosResponse<User>>;
};
